// extracted by mini-css-extract-plugin
export default {"cardsGrid":"Cards_cardsGrid__i+Uy1"};